export class FormType<T> {
  value: T;
  key: string;
  label: string;
  required: boolean;
  max: string;
  min: string;
  maxLength: number;
  minLength: number;
  maxDate: string;
  minDate: string;
  order: number;
  controlType: string;
  focus: boolean;
  type: string;
  placeholder: string;
  options: { key: string, value: string, checked?: boolean }[];
  layout: string;
  directives: string;
  customValidate: string | string[];
  updateOn: string;
  template: string;
  reset: boolean;
  title: boolean;
  pattern: string;
  constructor(options: {
    value?: T;
    key?: string;
    label?: string;
    required?: boolean;
    max?: string;
    min?: string;
    maxLength?: number;
    minLength?: number;
    maxDate?: string;
    minDate?: string;
    order?: number;
    controlType?: string;
    focus?: boolean;
    type?: string;
    placeholder?: string;
    options?: { key: string, value: string }[];
    layout?: string;
    directives?: string;
    customValidate?: string | string[];
    updateOn?: string;
    template?: string;
    reset?: boolean;
    title?: boolean;
    pattern?: string;
  } = {}) {
    this.value = options.value;
    this.key = options.key || '';
    this.label = options.label || '';
    this.required = !!options.required;
    this.max = options.max || null;
    this.min = options.min || null;
    this.maxLength = options.maxLength || null;
    this.minLength = options.minLength || null;
    this.maxDate = options.maxDate || null;
    this.minDate = options.minDate || null;
    this.order = options.order === undefined ? 1 : options.order;
    this.controlType = options.controlType || '';
    this.type = options.type || '';
    this.placeholder = options.placeholder || '';
    this.focus = !!options.focus;
    this.options = options.options || [];
    this.layout = options.layout || '100';
    this.directives = options.directives || '';
    this.customValidate = options.customValidate || '';
    this.updateOn = options.updateOn || '';
    this.template = options.template || '';
    this.reset = !!options.reset;
    this.title = options.title;
    this.pattern =  options.pattern || '';
  }
}
